module.exports = __webpack_public_path__ + "img/MG-price-m.cbc32787.png";